<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area invest03">
      <img
        :src="`${resources}img/img-top-sub-title11.jpg`"
        alt=""
        v-if="device === 'mo'"
      />
      <div class="tit_area">
        <div class="sub_tit">공시정보</div>
        <div class="sub_txt">
          수시/정기 공시정보를 다운로드 하실 수 있습니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="flex_box">
        <h3>공시정보</h3>
        <div class="selectbox3 vselect ty_wid" v-if="device === 'pc'">
          <v-select v-model="year" :options="options" :searchable="false">
          </v-select>
        </div>
        <div class="selectbox3 ty_wid" v-else>
          <!-- 스크립트 필요 부분 - 셀렉트 선택 시 active class추가 부탁드립니다.-->
          <select id="select" v-model="year">
            <option v-for="val in this.options" :key="val.id">{{ val }}</option>
          </select>
          <i class="ico_select"></i>
        </div>
      </div>
      <div class="tbl_scroll_area tbl_min" v-if="device === 'mo'">
        <div class="tbl_ty02 bod">
          <table>
            <caption>
              공시정보: 번호,제목,작성일,작성자로 구성
            </caption>
            <colgroup>
              <col style="width: 20%" />
              <col style="width: auto" />
              <col style="width: 20%" />
              <col style="width: 20%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">번호</th>
                <th scope="col">제목</th>
                <th scope="col">작성일</th>
                <th scope="col">작성자</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in listItems" :key="`inverst-tr-${idx}`">
                <td v-html="getNo(item.rcept_no)"></td>
                <td class="aLeft">
                  <a href="#" @click.prevent="clickBbs(item.rcept_no)">{{
                    item.report_nm
                  }}</a>
                </td>
                <td>{{ getDate(item.rcept_dt) }}</td>
                <td>{{ item.flr_nm }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="tbl_ty02 bod" v-else>
        <table>
          <caption>
            공시정보: 번호,제목,작성일,작성자로 구성
          </caption>
          <colgroup>
            <col style="width: 20%" />
            <col style="width: auto" />
            <col style="width: 20%" />
            <col style="width: 20%" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">번호</th>
              <th scope="col">제목</th>
              <th scope="col">작성일</th>
              <th scope="col">작성자</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in listItems" :key="`inverst-tr-${idx}`">
              <td v-html="getNo(item.rcept_no)"></td>
              <td class="aLeft">
                <a href="#" @click.prevent="clickBbs(item.rcept_no)">{{
                  item.report_nm
                }}</a>
              </td>
              <td>{{ getDate(item.rcept_dt) }}</td>
              <td>{{ item.flr_nm }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="btn_cnt_wrap"
        v-if="device === 'mo' && curPageIdx + 1 !== this.viewPageLength"
        @click.prevent="changePage(showPageLabel(curPageIdx + 1) - 1)"
      >
        <button type="button" class="btn_morelist">더보기</button>
      </div>
      <!-- paging -->
      <div class="paging_item" v-if="device === 'pc'">
        <div class="btn_area">
          <a
            href="#"
            :class="['btn_first', { inactive: isFirst }]"
            @click.prevent="firstPage($event)"
            >첫페이지</a
          >
          <a
            href="#"
            :class="['btn_prev', { inactive: isFirst }]"
            @click.prevent="prevPage($event)"
            >이전</a
          >
        </div>
        <div class="paging">
          <a
            v-for="(item, idx) in viewPageLength"
            :class="{ active: isCurrent(idx) }"
            :key="`paging-atag-${idx}`"
            href="#"
            @click.prevent="changePage(showPageLabel(idx) - 1)"
            >{{ showPageLabel(idx) }}</a
          >
        </div>
        <div class="btn_area">
          <a
            href="#"
            :class="['btn_next', { inactive: isLast }]"
            @click.prevent="nextPage($event)"
            >다음</a
          >
          <a
            href="#"
            :class="['btn_last', { inactive: isLast }]"
            @click.prevent="lastPage($event)"
            >마지막페이지</a
          >
        </div>
      </div>
      <!-- paging -->
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>
<script>
import invest020 from './p_invest020';

export default invest020;
</script>

<style lang="scss" scoped></style>
